import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import HowStorageServicesWorksPage from '@/v2/components/pages/public-pages/how-storage-services-works-page'
import {
  faqSectionContent,
  metaImages,
  ogImages
} from '@/v2/constants/pages/public-pages/how-storage-services-works-page'

interface HowStorageServicesWorkPageProps {}

const Page: React.FC<HowStorageServicesWorkPageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.how_storage_services_works.title ?? ''}
        keywords={META_CONTENTS.how_storage_services_works?.keywords ?? ''}
        description={META_CONTENTS.how_storage_services_works?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <HowStorageServicesWorksPage />
    </>
  )
}

export default Page
